import { IConnection } from "../../models";
import * as types from "../constants";

export function addCacheConnection(connection: IConnection) {
  return {
    type: types.ADD_CONNECTION,
    payload: connection,
  };
}
